import React from "react";
import { Box, Button, alpha } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

interface PhlebotomyBackButtonProps {
  onClick: () => void;
}

const PhlebotomyBackButton: React.FC<PhlebotomyBackButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();
  const label = t("phlebotomy.buttons.back");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        px: 0,
        pt: 1.5,
        pb: 0.5,
      }}
    >
      {/* One hit target for icon + label, matching Change location. */}
      <Button
        variant="text"
        onClick={onClick}
        startIcon={<ArrowBackIcon />}
        aria-label={label}
        sx={(theme) => ({
          color: theme.palette.custom.redMedium,
          textTransform: "none",
          letterSpacing: "0.04em",
          fontWeight: 600,
          minHeight: 30,
          px: 0,
          py: "2px",
          "& .MuiButton-startIcon": {
            marginRight: 1,
          },
          "&:hover": {
            backgroundColor: alpha(theme.palette.custom.redMedium, 0.04),
          },
        })}
      >
        {label}
      </Button>
    </Box>
  );
};

export default PhlebotomyBackButton;
